import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Redirect } from 'react-router';
import useInjectSaga from '../../../../../utils/injectSaga';
import { makeFavorite } from '../../../../../selectors/FavouriteSearch/selector';
import saga from '../../../../../saga/Recent/saga';
import {
  getFavoriteData,
  updateFavoriteData
} from '../../../../../actions/Favorite/action';
import {
  getLoading,
  getRefreshStatus,
  getNetworkStatus,
  getUserMasterData,
  getUserData
} from '../../../../../selectors/selector';
import { showAlert } from '../../../../../actions/App/action';
import { Favorite } from '../../../../../models/home/favorite.model';
import { fetchResults } from '../../../../../actions/Search/action';
import { RecentSearch } from '../../../../pages/Search/SavedSearch/Recent/RecentPage.page';
import { makeSearch } from '../../../../../selectors/Search/selector';
import {
  PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
  NO_NETWORK,
  FAVORITE_SEARCH_REMOVED
} from '../../../../../utils/constants';
import { DomainConverter } from '../../../../../utils/common';
import { ILoadSearchResults } from '../../../../../schemas/Search/Search.schema';
import { SearchResults } from '../../../../../models/home/SearchResults.model';
import { ToastMessage } from '../../../../../utils/ToastMessage';
import { getDestinationStateValue, getSearchInputes } from '../../searchUtility';
import { setScreenName } from '../../../../../utils/Analytics';

const key = 'recent';
let onSearch = false;
let searchParams: any = null;
let modelSearch: any = null;
let detailObj: any = null;
export class FavouriteContainer extends PureComponent<any, any> {
  model: Favorite;

  constructor(props: any) {
    super(props);
    this.state = {
      id: [],
      data: {}
    };
    this.model = new Favorite();
  }

  componentDidMount() {
    this.getFavoriteSearchList(false);
    setScreenName('favourite_list_page');
  }

  updateFavorite = (fav: boolean, data: any) => {
    if (!this.props.isNetworkAvailable) {
      showAlert({
        isShowAlert: true,
        alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
        alertTitle: NO_NETWORK
      });
      return;
    }
    let newData = {
      ...data,
      favouritesearchindicator: fav,
      destinationStates: getDestinationStateValue(data)
    };

    delete newData.destinationState1;
    delete newData.destinationState2;
    delete newData.destinationState3;

    const arr = this.state.id;
    arr.push(data.id);
    this.setState({
      id: arr, data: {
        ...data,
        favouritesearchindicator: fav,
      }
    });
    this.props.updateFavoriteLoads(
      this.model.updateFavoriteLoad(newData),
      false
    );
    ToastMessage.open({
      message: FAVORITE_SEARCH_REMOVED,
      showUndo: true,
      callback: this.undoClicked
    });
  };

  undoClicked = () => {
    const data = {
      ...this.state.data,
      favouritesearchindicator: !this.state.data.favouritesearchindicator,
      destinationStates: getDestinationStateValue(this.state.data)
    };
    delete data.destinationState1;
    delete data.destinationState2;
    delete data.destinationState3;
    this.props.updateFavoriteLoads(this.model.updateFavoriteLoad(data), false);
    const arr = this.state.id;
    arr.pop();
    this.setState({ id: arr });
  };

  getFavoriteSearchList = (isHideLoader: boolean) => {
    if (!this.props.isNetworkAvailable) {
      return;
    }
    this.model.userID =
      (this.props.userDetails &&
        this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.upn) ||
      '';
    this.model.carrierId =
      (this.props.userDetails &&
        this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.carrierId) || '';
    this.model.page = 0;
    this.model.size = 10;
    this.props.favoriteLoads(this.model.getFavoritePayload(), isHideLoader);
  };

  onSearchResult = (searchData: any, details:any) => {
    searchParams = searchData;
    detailObj = details;
    onSearch = true;
    modelSearch = getSearchInputes(
      searchData,
      this.props.userDetails
    );
    this.props.fetchData(modelSearch.getRequestPayload());
  };

  render() {
    return this.props &&
      this.props.data &&
      this.props.data.searchLoads &&
      onSearch ? (
      ((onSearch = false),
        (
          <Redirect
            to={{
              pathname: '/app/search/results',
              state: {
                data: DomainConverter.dataToDomain<ILoadSearchResults>(
                  SearchResults,
                  this.props.data
                ),
                params: searchParams,
                detailObj: detailObj,
                tabFrom: this.props.tabFrom,
                showResults: true,
                searchInput: searchParams
              }
            }}
          />
        ))
    ) : (
      <RecentSearch
        getLoads={
          this.props.favoriteLoadsData.Favorite.data &&
          this.props.favoriteLoadsData.Favorite.data
            .findUserFavouriteSearchHistory
        }
        favoriteFlag
        isInPullToRefresh={this.props.isInPullToRefresh}
        getFavoriteSearchList={this.getFavoriteSearchList}
        isNetworkAvailable={this.props.isNetworkAvailable}
        showAlert={this.props.showAlert}
        onSearchResult={this.onSearchResult}
        updateFavorite={this.updateFavorite}
        id={this.state.id}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  loading: getLoading(),
  favoriteLoadsData: makeFavorite(),
  isInPullToRefresh: getRefreshStatus(),
  isNetworkAvailable: getNetworkStatus(),
  userDetails: getUserMasterData(),
  data: makeSearch(),
  userData: getUserData()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  favoriteLoads: (favoriteSearch: any, isHideLoader: boolean) =>
    dispatch(getFavoriteData(favoriteSearch, isHideLoader)),
  showAlert: (data: any) => dispatch(showAlert(data)),
  fetchData: (searchData: any) => dispatch(fetchResults(searchData, false, false)),
  updateFavoriteLoads: (favoriteSearch: any, isHideLoader: boolean) =>
    dispatch(updateFavoriteData(favoriteSearch, isHideLoader))
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = useInjectSaga({ key, saga });

export default compose<any>(
  withSaga,
  withConnect
)(FavouriteContainer);
